import { render } from "./EmailLogs.vue?vue&type=template&id=94034908&scoped=true"
import script from "./EmailLogs.vue?vue&type=script&lang=js"
export * from "./EmailLogs.vue?vue&type=script&lang=js"

import "./EmailLogs.vue?vue&type=style&index=0&id=94034908&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94034908"]])

export default __exports__